// extracted by mini-css-extract-plugin
export default {"second-title":"FormChangePassword_second-title__yfWH+","buttons":"FormChangePassword_buttons__8enzs","color":"FormChangePassword_color__jNHHl"};